import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: false,
};

export const SYSTEM_STORE_NAME = "warehouse";

const systemSlice = createSlice({
  name: SYSTEM_STORE_NAME,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder

      //fulfilled matcher
      .addMatcher(
        action => action.type.startsWith(SYSTEM_STORE_NAME) && action.type.endsWith("/fulfilled"),
        state => handleFulfilled(state),
      )
      //pending matcher
      .addMatcher(
        action => action.type.startsWith(SYSTEM_STORE_NAME) && action.type.endsWith("/pending"),
        state => handlePending(state),
      )
      //rejected matcher
      .addMatcher(
        action => action.type.startsWith(SYSTEM_STORE_NAME) && action.type.endsWith("/rejected"),
        (state, {error}) => handleRejected(state, error),
      )
      //default
      .addDefaultCase(() => {});
  },
});

const {actions, reducer} = systemSlice;
export default reducer;

export const {smth} = actions;

function handleFulfilled(state) {
  state.loading = false;
  state.error = false;
}

function handlePending(state) {
  state.loading = true;
  state.error = false;
}

function handleRejected(state, error) {
  state.loading = false;
  state.error = error;
}
